// import jQuery from 'jquery'

const loginUrl = process.env.VUE_APP_loginUrl;
const accountUrl = process.env.VUE_APP_accountUrl;
const baseUrl = process.env.VUE_APP_baseUrl;
const routerBase = process.env.VUE_APP_routerBase;

export function validate(params) {
    return new Promise((resolve, reject) => {
      jQuery.ajax({
        url:`${accountUrl}/api/validate`,    //请求的url地址
        dataType: "jsonp",
        jsonpCallback:"successCallback",
        type:"get",   //请求方式
        success:function(result){
          resolve(result);
        },
        error:function(error){
          let url = loginUrl+'/login?service='+baseUrl+routerBase
          window.location.href = url;
        }
      })
    })
  }